import * as React from 'react';
import { SVGProps } from 'react';

const Refresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={11}
    height={11}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      clipPath="url(#a)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.018 2.232v2.5h-2.5M.85 8.898v-2.5h2.5" />
      <path d="M1.896 4.315a3.75 3.75 0 0 1 6.188-1.4l1.933 1.817M.851 6.4l1.933 1.816a3.75 3.75 0 0 0 6.187-1.4" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.434 .565)" d="M0 0h10v10H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default Refresh;
